<template>
    <div>
        <template v-if="showings.length > 0">
            <v-row
                v-for="showing in showings"
                :key="showing.id"
                no-gutters
                class="mb-2 mx-2"
            >
                <v-col cols="5" class="text-left pl-2">
                    <channel
                        :channel="showing.channel"
                        :showingId="showing.id"
                        :lit="currentLitShowings.includes(showing.id)"
                        @channel-click="liteChannel(showing.id)"
                    />
                </v-col>
                <v-col cols="2">
                    <v-chip
                        color="primary"
                        class="rounded pl-3 font-weight-bold subtitle-1"
                    >
                        {{ getShowingFormat(showing) }}
                    </v-chip>
                </v-col>

                <v-col cols="2" class="text-center">
                    <v-chip
                        color="transparent"
                        class="rounded red--text pl-3 subtitle-2"
                    >
                        {{ getShowingType(showing) }}
                    </v-chip>
                </v-col>
                <v-col cols="3" class="text-right" :class="timeClass(showing)">
                    <v-chip
                        color="transparent"
                        :class="isOnNow(showing) ? 'red--text' : ''"
                        class="rounded pl-3 font-weight-bold"
                    >
                        {{ getTimeDisplay(showing) }}
                    </v-chip>
                </v-col>
            </v-row>
        </template>
    </div>
</template>

<script>
import Channel from "./Channel";
export default {
    name: "ShowingsTable",
    components: {
        Channel,
    },
    props: {
        showings: {
            type: Array,
            required: true,
        },
        currentLitShowings: {
            type: Array,
            required: false,
        },
    },
    computed: {
        timezone() {
            return this.$store.getters.getCurrentSelectedOptions(
                "timezoneString"
            );
        },
    },
    methods: {
        getShowingType(showing) {
            if (showing.showing_type_id == 2) return "JIP";
            if (showing.showing_type_id == 3) return "HGLT";
            if (showing.showing_type_id == 4) return "REPLAY";
            return "· LIVE";
        },
        isOnNow(showing) {
            const showingTime = moment(showing.starts_at).tz(this.timezone);
            const currentTime = moment().tz(this.timezone);

            return showingTime.isSame(currentTime, "minute");
        },
        getTimeDisplay(showing) {
            const showingTime = moment(showing.starts_at).tz(this.timezone);
            const currentTime = moment().tz(this.timezone);

            if (this.isOnNow(showing)) {
                return "ON NOW";
            }

            return showingTime.format("h:mmA");
        },
        timeClass(showing) {
            const showingTime = moment(showing.starts_at).tz(this.timezone);
            const currentTime = moment().tz(this.timezone);

            if (showingTime.isSame(currentTime, "minute")) {
                return "text-primary";
            }

            return "";
        },
        getShowingFormat(showing) {
            if (showing.uhd) return "4K";
            if (showing.hd) return "HD";
            return "SD";
        },
        liteChannel(showingId) {
            console.log("liteChannel", showingId);
            this.$emit("channel-click", showingId);
        },
    },
};
</script>
